import { FC, useEffect, useRef } from 'react';
import { useSubmissionModalContext } from './SubmissionModal.context';
import { LINKS } from '@silo/types';
import { Button, ExternalLink } from '@silo/ui';

export const UnstableOracleWarning: FC = () => {
  const { cancel, submit } = useSubmissionModalContext();
  const submitButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    submitButtonRef.current?.focus();
  }, []);

  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-xl font-medium">Oracle warning</h2>

      <div className="flex flex-col gap-2.5" data-cy="unstable-oracle-warning">
        <p className="text-base">
          The base asset in this silo uses an oracle that may be manipulated which poses increased risk.
        </p>
        <ExternalLink href={LINKS.SILOPEDIA.ORACLE_RISK} size="small" />
      </div>

      <div className="flex gap-2.5">
        <Button variant="secondary" onClick={cancel}>
          Cancel
        </Button>
        <Button variant="primary" ref={submitButtonRef} onClick={submit}>
          Continue
        </Button>
      </div>
    </div>
  );
};
